import { render, staticRenderFns } from "./FOTP.vue?vue&type=template&id=4ae97da6&"
import script from "./FOTP.vue?vue&type=script&lang=ts&"
export * from "./FOTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports